import { withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EvolucaoExame from "./Layouts/EvolucaoExame/EvolucaoExame";
import FormPessoa from "./Layouts/FormPessoa/FormPessoa";
import ProdutoItens from "./Layouts/ProdutoItens";
import TabelaHoras from "./Layouts/TabelaHoras/TabelaHoras";

const styles = (theme) => ({
    item: {
        paddingLeft: 3 * theme.spacing.unit,
    }
});

class FormularioFactory extends XAPPComponent {

    getLayout = () => {
        const { item, isGestor, formulario, onChangeImage, customProps, readOnly, onChange, onChangeMask, xappRouteParams, onChangeForm, fluxo, pessoaformulario } = this.props;
        if (formulario !== undefined && formulario !== null) {
            switch (item.tipo) {
                case "tabelahoras":
                    return (
                        <TabelaHoras
                            item={item}
                            formulario={formulario}
                            readOnly={readOnly}
                            onChange={onChange}
                            onChangeMask={onChangeMask}
                            xappRouteParams={xappRouteParams}
                            onChangeForm={onChangeForm}
                            fluxo={fluxo}
                            customProps={customProps}
                            pessoaformulario={pessoaformulario}
                        />
                    );
                case "formpessoa":
                    return (
                        <FormPessoa
                            item={item}
                            formulario={formulario}
                            readOnly={readOnly}
                            onChange={onChange}
                            onChangeMask={onChangeMask}
                            xappRouteParams={xappRouteParams}
                            onChangeForm={onChangeForm}
                            customProps={customProps}
                            isGestor={isGestor}
                            onChangeImage={onChangeImage}
                        />
                    );
                case "produtoitens":
                    return (
                        <ProdutoItens
                            item={item}
                            formulario={formulario}
                            readOnly={readOnly}
                            onChange={onChange}
                            onChangeMask={onChangeMask}
                            customProps={customProps}
                            xappRouteParams={xappRouteParams}
                            onChangeForm={onChangeForm}
                        />
                    );
                case "evolucao-exame":
                    return (
                        <EvolucaoExame
                            item={item}
                            formulario={formulario}
                            readOnly={readOnly}
                            onChange={onChange}
                            onChangeMask={onChangeMask}
                            customProps={customProps}
                            xappRouteParams={xappRouteParams}
                            onChangeForm={onChangeForm}
                        />
                    );
                default:
                    return (
                        <div />
                    );
            }
        }
    };

    render() {
        return (
            <React.Fragment>
                {this.getLayout()}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // list         : Actions.list,
    }, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        theme: fuse.settings.mainTheme
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FormularioFactory)));
